import { SuperAdminService } from "services/superAdminService";

class TriggerTypesSAService extends SuperAdminService<any> {
    constructor() {
        super("trigger-types");
    }
}
export default new TriggerTypesSAService();
